/*
 * @Descripttion:
 * @Author: zhangxu
 * @Date: 2025-05-12 14:19:19
 * @LastEditors: zhangxu
 * @LastEditTime: 2025-09-12 15:25:26
 */
export default {
  data() {
    return {
      searchMethodName: 'getList',
      isComponentActive: false,
      lastSearchTime: 0,
      throttleDelay: 1000
    }
  },
  created() {
    this.isComponentActive = true
  },
  destroyed() {
    this.isComponentActive = false
  },
  activated() {
    this.isComponentActive = true
  },
  deactivated() {
    this.isComponentActive = false
  },
  mounted() {
    document.addEventListener('keyup', this.handleKeyDown)
  },
  methods: {
    handleKeyDown(event) {
      if (event.key === 'Enter' && this.isComponentActive) {
        const now = Date.now()
        if (now - this.lastSearchTime < this.throttleDelay) {
          return
        }
        this.lastSearchTime = now
        if (typeof this[this.searchMethodName] === 'function') {
          this[this.searchMethodName]('reset')
        } else if (typeof this['searchHandle'] === 'function') {
          this['searchHandle']()
        } else if (typeof this['searchFormData'] === 'function') {
          this['searchFormData']()
        }
      }
    }
  },
  beforeDestroy() {
    // 确保在组件销毁时移除事件监听器
    if (this.handleKeyDown) {
      document.removeEventListener('keyup', this.handleKeyDown)
      this.handleKeyDown = null
    }
  }
}
